var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNetworkError = function SvgNetworkError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 57.997C30.733 57.997 29.467 57.516 28.503 56.552L7.44795 35.497C5.51995 33.568 5.51995 30.432 7.44795 28.503L11.7 24.251C10.599 22.724 9.99995 20.892 9.99995 19C9.99995 14.037 14.037 9.99995 19 9.99995C20.892 9.99995 22.724 10.599 24.251 11.7L28.503 7.44795C30.431 5.51995 33.569 5.51995 35.497 7.44795L56.552 28.503C58.48 30.432 58.48 33.568 56.552 35.497L35.497 56.552C34.533 57.516 33.267 57.997 32 57.997ZM19 12C15.141 12 12 15.141 12 19C12 20.716 12.635 22.369 13.786 23.657L14.417 24.362L8.86195 29.917C7.71495 31.065 7.71495 32.935 8.86195 34.083L29.917 55.138C31.065 56.285 32.935 56.285 34.083 55.138L55.138 34.083C56.285 32.935 56.285 31.065 55.138 29.917L34.083 8.86295C32.933 7.71495 31.063 7.71495 29.917 8.86295L24.362 14.418L23.657 13.787C22.369 12.635 20.716 12 19 12Z",
    fill: "url(#paint0_linear_2838_217946)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57.997C30.733 57.997 29.467 57.516 28.503 56.552L7.44795 35.497C5.51995 33.568 5.51995 30.432 7.44795 28.503L11.7 24.251C10.599 22.724 9.99995 20.892 9.99995 19C9.99995 14.037 14.037 9.99995 19 9.99995C20.892 9.99995 22.724 10.599 24.251 11.7L28.503 7.44795C30.431 5.51995 33.569 5.51995 35.497 7.44795L56.552 28.503C58.48 30.432 58.48 33.568 56.552 35.497L35.497 56.552C34.533 57.516 33.267 57.997 32 57.997ZM19 12C15.141 12 12 15.141 12 19C12 20.716 12.635 22.369 13.786 23.657L14.417 24.362L8.86195 29.917C7.71495 31.065 7.71495 32.935 8.86195 34.083L29.917 55.138C31.065 56.285 32.935 56.285 34.083 55.138L55.138 34.083C56.285 32.935 56.285 31.065 55.138 29.917L34.083 8.86295C32.933 7.71495 31.063 7.71495 29.917 8.86295L24.362 14.418L23.657 13.787C22.369 12.635 20.716 12 19 12Z",
    fill: "url(#paint1_linear_2838_217946)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54.1706C31.198 54.1706 30.443 53.8576 29.876 53.2906L10.71 34.1246C10.143 33.5576 9.82996 32.8026 9.82996 32.0006C9.82996 31.1986 10.143 30.4436 10.71 29.8766L15.293 25.2936L16.707 26.7076L12.124 31.2906C11.935 31.4806 11.83 31.7326 11.83 32.0006C11.83 32.2686 11.934 32.5206 12.124 32.7106L31.29 51.8766C31.671 52.2556 32.329 52.2556 32.71 51.8766L51.876 32.7106C52.065 32.5206 52.17 32.2686 52.17 32.0006C52.17 31.7326 52.066 31.4806 51.876 31.2906L32.71 12.1246C32.329 11.7456 31.671 11.7456 31.29 12.1246L26.707 16.7076L25.293 15.2936L29.876 10.7106C31.011 9.57563 32.989 9.57563 34.124 10.7106L53.29 29.8766C53.857 30.4436 54.17 31.1986 54.17 32.0006C54.17 32.8026 53.857 33.5576 53.29 34.1246L34.124 53.2906C33.557 53.8586 32.802 54.1706 32 54.1706Z",
    fill: "url(#paint2_linear_2838_217946)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54.1706C31.198 54.1706 30.443 53.8576 29.876 53.2906L10.71 34.1246C10.143 33.5576 9.82996 32.8026 9.82996 32.0006C9.82996 31.1986 10.143 30.4436 10.71 29.8766L15.293 25.2936L16.707 26.7076L12.124 31.2906C11.935 31.4806 11.83 31.7326 11.83 32.0006C11.83 32.2686 11.934 32.5206 12.124 32.7106L31.29 51.8766C31.671 52.2556 32.329 52.2556 32.71 51.8766L51.876 32.7106C52.065 32.5206 52.17 32.2686 52.17 32.0006C52.17 31.7326 52.066 31.4806 51.876 31.2906L32.71 12.1246C32.329 11.7456 31.671 11.7456 31.29 12.1246L26.707 16.7076L25.293 15.2936L29.876 10.7106C31.011 9.57563 32.989 9.57563 34.124 10.7106L53.29 29.8766C53.857 30.4436 54.17 31.1986 54.17 32.0006C54.17 32.8026 53.857 33.5576 53.29 34.1246L34.124 53.2906C33.557 53.8586 32.802 54.1706 32 54.1706Z",
    fill: "url(#paint3_linear_2838_217946)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14C17.6739 14 16.4021 14.5268 15.4645 15.4645C14.5268 16.4021 14 17.6739 14 19C14 20.3261 14.5268 21.5979 15.4645 22.5355C16.4021 23.4732 17.6739 24 19 24C20.3261 24 21.5979 23.4732 22.5355 22.5355C23.4732 21.5979 24 20.3261 24 19C24 17.6739 23.4732 16.4021 22.5355 15.4645C21.5979 14.5268 20.3261 14 19 14Z",
    fill: "url(#paint4_linear_2838_217946)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20H33V36H31V20Z",
    fill: "url(#paint5_linear_2838_217946)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44C30.897 44 30 43.103 30 42C30 40.897 30.897 40 32 40C33.103 40 34 40.897 34 42C34 43.103 33.103 44 32 44Z",
    fill: "url(#paint6_linear_2838_217946)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2838_217946",
    x1: 32,
    y1: 5.74995,
    x2: 32,
    y2: 58.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2838_217946",
    x1: 32,
    y1: 4.5021,
    x2: 32,
    y2: 59.0229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9529B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2838_217946",
    x1: 32,
    y1: 5.75063,
    x2: 32,
    y2: 58.0066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2838_217946",
    x1: 32,
    y1: 8.58117,
    x2: 32,
    y2: 55.0449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9529B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2838_217946",
    x1: 19,
    y1: 13.5,
    x2: 19,
    y2: 24.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AB4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E492FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2838_217946",
    x1: 32,
    y1: 5.75,
    x2: 32,
    y2: 58.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2838_217946",
    x1: 32,
    y1: 5.75,
    x2: 32,
    y2: 58.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNetworkError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "network-error.17f5b46938dd5f0e43b5daebc0689fc0.svg";